// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, headingColorOpt, colorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.pink400;
  var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme__Color$PrezzeeRibbon.gray800;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.gray600;
  return {
          backgroundColor: backgroundColor,
          headingColor: headingColor,
          color: color
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
